import React from "react";
import { Helmet } from "react-helmet-async";

export default function TermsOfUse() {
  return (
    <div className="min-h-screen bg-white text-slate-900">
      <Helmet>
        <title>Terms of Use – OjoVest</title>
        <link rel="canonical" href="https://www.ojovest.com/terms" />
      </Helmet>

      <div className="mx-auto max-w-4xl px-4 py-12">
        <h1 className="text-3xl font-semibold tracking-tight">Terms of Use</h1>
        <p className="mt-3 text-sm text-slate-600">
          Last updated: {new Date().toLocaleDateString()}
        </p>

        <div className="mt-8 space-y-5 text-sm leading-7 text-slate-700">
          <p>
            By using OjoVest, you agree to these Terms. We provide assistance and advisory support
            for loan/credit card applications. Final approval, pricing, and terms are determined by
            banks/NBFCs/issuers.
          </p>

          <p>
            You agree to provide accurate information. Submitting false or misleading information
            may result in rejection and may be reported to relevant parties.
          </p>

          <p>
            OjoVest may update these Terms at any time. Continued use means you accept the updates.
          </p>

          <p>
            Governing law: India. Disputes are subject to jurisdiction as applicable under Indian law.
          </p>
        </div>
      </div>
    </div>
  );
}
